import { render, staticRenderFns } from "./editCubeV2.vue?vue&type=template&id=716918bd&scoped=true&"
import script from "./editCubeV2.vue?vue&type=script&lang=js&"
export * from "./editCubeV2.vue?vue&type=script&lang=js&"
import style0 from "./editCubeV2.vue?vue&type=style&index=0&id=716918bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716918bd",
  null
  
)

export default component.exports